import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Cookie } from "lucide-react";
import { analyticsAvailable, CONSENT_KEY, loadAnalytics } from "@/lib/analytics";
import { isNative } from "@/lib/native";

const SEEN_KEY = "fg_cookie_notice_seen";

export default function CookieNotice() {
  const [seen, setSeen] = useState(() => localStorage.getItem(SEEN_KEY) === "1");
  if (seen || isNative) return null;
  const withAnalytics = analyticsAvailable();
  const finish = (consent) => {
    localStorage.setItem(SEEN_KEY, "1");
    localStorage.setItem(CONSENT_KEY, consent);
    if (consent === "granted") loadAnalytics();
    setSeen(true);
  };
  return (
    <div className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:right-6 sm:max-w-sm z-50 rounded-2xl border border-border bg-card shadow-xl p-4 flex gap-3 items-start" role="dialog" aria-label="Cookie preferences" data-testid="cookie-notice">
      <Cookie className="w-5 h-5 text-primary shrink-0 mt-0.5" />
      <div className="text-sm">
        {withAnalytics ? (
          <p className="text-muted-foreground leading-relaxed">We use essential cookies to keep you signed in, and — with your OK — anonymous Google Analytics to see which pages help most. <Link to="/cookies" className="text-primary hover:underline">Cookie notice</Link></p>
        ) : (
          <p className="text-muted-foreground leading-relaxed">We only use essential cookies to keep you signed in and protect your account — no tracking. <Link to="/cookies" className="text-primary hover:underline">Cookie notice</Link></p>
        )}
        <div className="flex gap-2 mt-3">
          {withAnalytics ? (
            <>
              <Button size="sm" onClick={() => finish("granted")} data-testid="cookie-notice-accept">Accept analytics</Button>
              <Button size="sm" variant="outline" onClick={() => finish("denied")} data-testid="cookie-notice-ok">Essential only</Button>
            </>
          ) : (
            <Button size="sm" onClick={() => finish("denied")} data-testid="cookie-notice-ok">Got it</Button>
          )}
        </div>
      </div>
    </div>
  );
}
